import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AcademicRoutes } from "./academicRouter";
import { BlogRoutes } from "./blogRouter";

const AppRouter = (props) => {
  return (
    // <BrowserRouter basename="/">
    <BrowserRouter basename="/apps/seacerca/prodep">
      <RouterApp auth={props.auth} />
    </BrowserRouter>
  );
};

const RouterApp = (props) => {
  return (
    <Routes>
      {/* /apps/seacerca/pagedemo/constancias */}
      {AcademicRoutes()} {/* solo para las constancias*/}
      {/* /apps/seacerca/pagedemo */}
      {BlogRoutes()} {/* solo para el blog */}
      {/* <Route path="*" element={<Navigate replace to="/404" />} /> */}
    </Routes>
  );
};

export default AppRouter;
